export const mapUserDto = (dto) => ({
    id: dto.id,
    username: dto.username,
    name: dto.name,
    email: dto.email,
    role: dto.role,
    is_active: dto.is_active,
    organisation_id: dto.organisation_id,
    projects: dto.projects,
});
